import { IProductToOptionGroupLinkData } from "common/records/ProductToOptionGroupLink";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_PRODUCT_TO_OPTION_GROUP_LINK = "@productToOptionGroupLink/RECEIVE_PRODUCT_TO_OPTION_GROUP_LINK";
export const RESET_PRODUCT_TO_OPTION_GROUP_LINK = "@productToOptionGroupLink/RESET_PRODUCT_TO_OPTION_GROUP_LINK";

export const ProductToOptionGroupLinkActions = {
  receiveProductToOptionGroupLink: (productToOptionGroupLink: Partial<IProductToOptionGroupLinkData>) =>
    createAction(RECEIVE_PRODUCT_TO_OPTION_GROUP_LINK, productToOptionGroupLink),
  resetProductToOptionGroupLink: (productToOptionGroupLinkId: number) =>
    createAction(RESET_PRODUCT_TO_OPTION_GROUP_LINK, { productToOptionGroupLinkId }),
};

export type ProductToOptionGroupLinkActions = ActionsUnion<typeof ProductToOptionGroupLinkActions>;
